import type { RailLayout } from "@/data/rail-branches";
import type { LocationRun } from "../LocationRun/runs";
import type { LocationBoxPlacement } from "./types";
import { placeLocationRuns } from "./place";

export function layoutSpreadLocationBoxes(
  runs: LocationRun[],
  playheadMs: number,
  viewportWidth: number,
  totalDurationMs: number,
  rail?: RailLayout,
): LocationBoxPlacement[] {
  return placeLocationRuns(
    runs,
    playheadMs,
    viewportWidth,
    totalDurationMs,
    true,
    rail,
  );
}
